import React, { useState } from 'react';
import { Lock, Eye, EyeOff, Loader2, AlertCircle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { Input } from './ui/input';

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    const result = await login(password);
    
    if (!result.success) {
      setError(result.error);
    }
    
    setIsLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <img
            src="https://customer-assets.emergentagent.com/job_b72b398f-341e-497f-a4a4-90e57f148212/artifacts/7jm7gror_logo-ss.png"
            alt="Shape & Shine"
            className="h-20 mx-auto mb-4"
          />
          <h1 className="font-display text-2xl text-gold-gradient">Área de Administração</h1>
          <p className="text-[#bbb5ae] text-sm mt-2">Acesso restrito</p>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="bg-[#111111] border border-[#C1A54F]/20 rounded-sm p-8">
          {error && (
            <div className="mb-6 p-4 bg-red-500/10 border border-red-500/30 rounded-sm flex items-center gap-3">
              <AlertCircle className="text-red-400 flex-shrink-0" size={20} />
              <span className="text-red-400 text-sm">{error}</span>
            </div>
          )}

          <div className="space-y-2 mb-6">
            <label className="text-[#f5f0e8] text-sm flex items-center">
              <Lock size={14} className="mr-2 text-[#E1C57C]" />
              Password de Administração
            </label>
            <div className="relative">
              <Input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full px-4 py-3 pr-12 rounded-none bg-[#0a0a0a] border-[#C1A54F]/20 text-[#f5f0e8]"
                placeholder="Introduza a password"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-[#bbb5ae] hover:text-[#E1C57C] transition-colors"
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>

          <Button
            type="submit"
            disabled={isLoading || !password}
            className="w-full btn-gold py-4 rounded-none font-medium tracking-wide"
          >
            {isLoading ? (
              <span className="flex items-center justify-center">
                <Loader2 className="animate-spin mr-2" size={18} />
                A verificar...
              </span>
            ) : (
              'ENTRAR'
            )}
          </Button>

          <div className="mt-6 text-center">
            <a
              href="/"
              className="text-[#bbb5ae] hover:text-[#E5B1C4] text-sm transition-colors"
            >
              ← Voltar ao site
            </a>
          </div>
        </form>

        {/* Security Notice */}
        <p className="text-center text-[#736c64] text-xs mt-6">
          Área protegida. Acesso não autorizado será registado.
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
